import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services';
import ConfirmDialog from '../../helpers/ConfirmDialog';

export const FavoriteDesignForm = ({ design, setDesigns }) => {
    const { token, base_url } = useAppContext();
    const isFavorited = design.is_favorited;

    return (
        <ConfirmDialog
            trigger={
                <button
                    className="btn btn-action btn-secondary"
                    title={isFavorited ? 'Unfavorite Design' : 'Favorite Design'}
                >
                    <FontAwesomeIcon
                        icon={faStar}
                        className={isFavorited ? 'favorite-star--active' : 'favorite-star--inactive'}
                    />
                    <span className="favorite-star--inactive">
                        {isFavorited ? 'Unfavorite' : 'Favorite'}
                    </span>
                </button>
            }
            title={`${isFavorited ? 'Unfavorite' : 'Favorite'} Design`}
            message={
                isFavorited
                    ? 'Remove this design from your favorites?'
                    : 'Want to favorite this design to make it easier to find later?'
            }
            entityLabel={`Design: ${design?.design_name}`}
            confirmLabel={isFavorited ? 'Unfavorite Design' : 'Favorite Design'}
            submittingLabel={isFavorited ? 'Unfavoriting...' : 'Favoriting...'}
            successMessage={
                isFavorited
                    ? 'Design unfavorited successfully!'
                    : 'Design favorited successfully!'
            }
            errorMessages={{
                notFound: 'Design not found',
                client: 'Invalid design data. Please check your input.',
                default: 'Failed to update favorite status. Please try again.',
            }}
            onConfirm={async () => {
                const updated_design = await updateData(
                    token,
                    `${base_url}/apis/designs/${design.id}`,
                    { is_favorited: !isFavorited }
                );

                if (!updated_design.design) return false;

                setDesigns((prevDesigns) =>
                    prevDesigns.map((d) =>
                        d.id === design.id ? updated_design.design : d
                    )
                );
            }}
        />
    );
};
